import {
  convertDayToHour,
  convertDayToYear,
  convertDayToWeek,
  convertDayToSecond,
  convertDayToMonth,
  convertDayToMinute
} from "./DayConversion";
import {
  convertHourToDay,
  convertHourToYear,
  convertHourToWeek,
  convertHourToSecond,
  convertHourToMonth,
  convertHourToMinute
} from "./HourConversion";
import {
  convertMinuteToDay,
  convertMinuteToHour,
  convertMinuteToMonth,
  convertMinuteToSecond,
  convertMinuteToWeek,
  convertMinuteToYear
} from "./MinuteConversion";
import {
  convertMonthToYear,
  convertMonthToWeek,
  convertMonthToSecond,
  convertMonthToMinute,
  convertMonthToHour,
  convertMonthToDay
} from "./MonthConversion";
import {
  convertSecondToDay,
  convertSecondToHour,
  convertSecondToMinute,
  convertSecondToMonth,
  convertSecondToWeek,
  convertSecondToYear
} from "./SecondConversion";
import {
  convertWeekToDay,
  convertWeekToHour,
  convertWeekToMinute,
  convertWeekToMonth,
  convertWeekToSecond,
  convertWeekToYear
} from "./WeekConversion";
import {
  convertYearToDay,
  convertYearToHour,
  convertYearToMinute,
  convertYearToMonth,
  convertYearToSecond,
  convertYearToWeek
} from "./YearConversion";

function getFinalDayConversion(temp, conType) {
  let result = "";
  if (conType === "datohr") {
    result = convertDayToHour(parseFloat(temp));
  } else if (conType === "datoyr") {
    result = convertDayToYear(parseFloat(temp));
  } else if (conType === "datowk") {
    result = convertDayToWeek(parseFloat(temp));
  } else if (conType === "datosd") {
    result = convertDayToSecond(parseFloat(temp));
  } else if (conType === "datomo") {
    result = convertDayToMonth(parseFloat(temp));
  } else if (conType === "datomn") {
    result = convertDayToMinute(parseFloat(temp));
  }
  return result;
}

function getFinalHourConversion(temp, conType) {
  let result = "";
  if (conType === "hrtoda") {
    result = convertHourToDay(parseFloat(temp));
  } else if (conType === "hrtoyr") {
    result = convertHourToYear(parseFloat(temp));
  } else if (conType === "hrtowk") {
    result = convertHourToWeek(parseFloat(temp));
  } else if (conType === "hrtosd") {
    result = convertHourToSecond(parseFloat(temp));
  } else if (conType === "hrtomo") {
    result = convertHourToMonth(parseFloat(temp));
  } else if (conType === "hrtomn") {
    result = convertHourToMinute(parseFloat(temp));
  }

  return result;
}

function getFinalMinuteConversion(temp, conType) {
  let result = "";
  if (conType === "mntoda") {
    result = convertMinuteToDay(parseFloat(temp));
  } else if (conType === "mntohr") {
    result = convertMinuteToHour(parseFloat(temp));
  } else if (conType === "mntomo") {
    result = convertMinuteToMonth(parseFloat(temp));
  } else if (conType === "mntosd") {
    result = convertMinuteToSecond(parseFloat(temp));
  } else if (conType === "mntowk") {
    result = convertMinuteToWeek(parseFloat(temp));
  } else if (conType === "mntoyr") {
    result = convertMinuteToYear(parseFloat(temp));
  }

  return result;
}

function getFinalMonthConversion(temp, conType) {
  let result = "";
  if (conType === "motoyr") {
    result = convertMonthToYear(parseFloat(temp));
  } else if (conType === "motowk") {
    result = convertMonthToWeek(parseFloat(temp));
  } else if (conType === "motosd") {
    result = convertMonthToSecond(parseFloat(temp));
  } else if (conType === "motomn") {
    result = convertMonthToMinute(parseFloat(temp));
  } else if (conType === "motohr") {
    result = convertMonthToHour(parseFloat(temp));
  } else if (conType === "motoda") {
    result = convertMonthToDay(parseFloat(temp));
  }
  return result;
}

function getFinalSecondConversion(temp, conType) {
  let result = "";
  if (conType === "sdtoda") {
    result = convertSecondToDay(parseFloat(temp));
  } else if (conType === "sdtohr") {
    result = convertSecondToHour(parseFloat(temp));
  } else if (conType === "sdtomn") {
    result = convertSecondToMinute(parseFloat(temp));
  } else if (conType === "sdtomo") {
    result = convertSecondToMonth(parseFloat(temp));
  } else if (conType === "sdtowk") {
    result = convertSecondToWeek(parseFloat(temp));
  } else if (conType === "sdtoyr") {
    result = convertSecondToYear(parseFloat(temp));
  }

  return result;
}

function getFinalWeekConversion(temp, conType) {
  let result = "";
  if (conType === "wktoda") {
    result = convertWeekToDay(parseFloat(temp));
  } else if (conType === "wktohr") {
    result = convertWeekToHour(parseFloat(temp));
  } else if (conType === "wktomn") {
    result = convertWeekToMinute(parseFloat(temp));
  } else if (conType === "wktomo") {
    result = convertWeekToMonth(parseFloat(temp));
  } else if (conType === "wktosd") {
    result = convertWeekToSecond(parseFloat(temp));
  } else if (conType === "wktoyr") {
    result = convertWeekToYear(parseFloat(temp));
  }

  return result;
}

function getFinalYearConversion(temp, conType) {
  let result = "";
  if (conType === "yrtoda") {
    result = convertYearToDay(parseFloat(temp));
  } else if (conType === "yrtohr") {
    result = convertYearToHour(parseFloat(temp));
  } else if (conType === "yrtomn") {
    result = convertYearToMinute(parseFloat(temp));
  } else if (conType === "yrtomo") {
    result = convertYearToMonth(parseFloat(temp));
  } else if (conType === "yrtosd") {
    result = convertYearToSecond(parseFloat(temp));
  } else if (conType === "yrtowk") {
    result = convertYearToWeek(parseFloat(temp));
  }
  return result;
}

export {
  getFinalDayConversion,
  getFinalHourConversion,
  getFinalMinuteConversion,
  getFinalMonthConversion,
  getFinalSecondConversion,
  getFinalWeekConversion,
  getFinalYearConversion
};
